"use client";

import Image from "next/image";
import Link from "next/link";

import Logo from "../Logo";
import ContactButton from "./ContactButton";
const styles = new Proxy({"Navbar":"Navbar-b7f24","Cursor":"Cursor-b7f24","ButtonNav":"ButtonNav-b7f24","ContactButton":"ContactButton-b7f24","SignInButton":"SignInButton-b7f24"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
/*import "./Mobilemenu.scss";*/
import { Fragment, useEffect } from "react";

export type MenuItem = {
  label: string;
  sublabel?: string;
  url: string;
  type: string;
  items?: Record<string, MenuItem[]>;
};

const Navbar = ({
  items,
  tenantData,
}: {
  items: MenuItem[];
  tenantData: { name?: string; domain?: string } | null;
}) => {
  useEffect(() => {
    const toggle = document.getElementById(
      "menu__toggle",
    ) as HTMLInputElement | null;
    if (!toggle) return;
    const handleChange = () => {
      document.body.style.overflow = toggle.checked ? "hidden" : "";
    };
    toggle.addEventListener("change", handleChange);
    return () => {
      toggle.removeEventListener("change", handleChange);
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div className="container">
      <nav
        className={`navbar fixed-top navbar-expand-lg navbar-dark ${styles.Navbar}`}
      >
        <div className="container">
          <Link href="/" className="navbar-brand">
            <span className={styles.NavLogo}>
              <Logo tenantData={tenantData} />
            </span>
          </Link>

          <input
            id="menu__toggle"
            type="checkbox"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          />
          <label className="menu__btn" htmlFor="menu__toggle">
            <span></span>
          </label>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav d-flex align-items-lg-center mx-auto mb-2 mb-lg-0">
              {items.map((item, index) => (
                <li
                  key={index}
                  className={"nav-item mx-0 mx-lg-3" + " position-relative"}
                >
                  <Link href={item.url} className="nav-link">
                    {item.label}
                  </Link>
                  {item.items && Object.keys(item.items).length > 0 && (
                    <ul>
                      {Object.entries(item.items).map(
                        ([group, subitems], subindex) => (
                          <div key={subindex} style={{ minWidth: "200px" }}>
                            <li key={subindex}>
                              <h5>{group}</h5>
                              {subitems.map((subitem, subitemIndex) => (
                                <Fragment key={subitemIndex}>
                                  <a
                                    key={subitemIndex}
                                    href={subitem.url}
                                    rel={
                                      subitem.type === "link"
                                        ? "noreferrer"
                                        : undefined
                                    }
                                    target={
                                      subitem.type === "link"
                                        ? "_blank"
                                        : undefined
                                    }
                                  >
                                    {subitem.label}
                                  </a>
                                  {(subitem.sublabel?.length ?? 0) > 0 ? (
                                    <span>{subitem.sublabel}</span>
                                  ) : null}
                                </Fragment>
                              ))}
                            </li>
                          </div>
                        ),
                      )}
                    </ul>
                  )}
                </li>
              ))}
            </ul>

            <ul
              id="navbar-buttons"
              className={`navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center ${styles.ButtonNav}`}
            >
              <li className="nav-item text-center">
                {tenantData?.domain === "www.cursorinsight.com" ? (
                  <Link
                    href="/contact"
                    className={`nav-link ${styles.SignInButton}`}
                  >
                    Contact
                  </Link>
                ) : tenantData?.domain === "www.kinerva.ai" ? (
                  <Link
                    href="/contact-us"
                    className={`nav-link ${styles.SignInButton}`}
                  >
                    Contact
                  </Link>
                ) : (
                  <ContactButton className={styles.SignInButton} />
                )}
              </li>
              {/* <li className="nav-item text-center">
                <a
                  href="https://demo.kinerva.ai/"
                  className={`nav-link ${styles.ContactButton}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Sign in
                </a>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
